import request from '../helpers/request';

const getRequestAttachment = async (requestId, fileName) => {
  const res = await request.get(
    `/Request/attachment`,
    { requestId, fileName },
    'Не удалось загрузить файл'
  );

  return res;
};

export default getRequestAttachment;
